<lui-dialog-container class="mw-2xl d-block" cdkTrapFocus>
  <lui-dialog-header>
    <div class="mat-h2">
      <span *ngIf="vm.title; else defaultTitle">{{ vm.title }}</span>
      <ng-template #defaultTitle>
        <span i18n>Are you sure?</span>
      </ng-template>
    </div>
    <button
      luiDialogClose
      luiIconButton
      size="xl"
      aria-label="Close"
      i18n-aria-label
      (click)="dialogRef.close(false)"
      *ngIf="vm.dismissible"
    >
      <mat-icon svgIcon="close_light"></mat-icon>
    </button>
  </lui-dialog-header>

  <lui-dialog-content>
    <ng-container *ngIf="isTemplateRef(content)">
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="contentDataContext"
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="isComponent(content)">
      <ndc-dynamic
        [ndcDynamicComponent]="content"
        [ndcDynamicInputs]="componentInputs"
      ></ndc-dynamic>
    </ng-container>
    <ng-container *ngIf="isString(content)">
      <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(content)"></div>
    </ng-container>
    <div
      class="bottom"
      luiIntersectionObserver
      (intersectionChange)="bottomVisibilityChange($event)"
    ></div>
  </lui-dialog-content>

  <lui-dialog-actions>
    <button
      *ngIf="vm.cancelButtonText"
      luiTextButton
      mat-dialog-close
      (click)="dialogRef.close(false)"
      data-test="cancel-button"
    >
      <mat-icon svgIcon="chevron_left"></mat-icon>
      {{ vm.cancelButtonText }}
    </button>
    <button
      *ngIf="vm.confirmButtonText"
      class="ms-auto"
      luiButton
      (click)="dialogRef.close(true)"
      [disabled]="!!vm.disableUntilScrolledToBottom && !bottomSeen"
      data-test="confirm-button"
      cdkFocusInitial
    >
      {{ vm.confirmButtonText }}
    </button>
  </lui-dialog-actions>
</lui-dialog-container>
